import config from '../config/api'

const util =  {
    dateFormat : function(_date){
        if(typeof _date != 'object'){
            return {};
        }

        // 小于10时补0
        function fix(num){
            return (num < 10)? '0' + num : num.toString();
        }

        // yyyy-MM-dd HH:mm:ss
        var year = _date.getFullYear()
            , month = _date.getMonth() + 1
            , date = _date.getDate()
            , day = _date.getDay()
            , hours = _date.getHours()
            , minutes = _date.getMinutes()
            , seconds = _date.getSeconds();

        var months = ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
            , months_en = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
            , months_abbr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
            , days = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
            , days_en = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thurday', 'Friday', 'Saturday']
            , days_abbr = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

        return {
            year: year,
            month: fix(month),
            date: fix(date),
            day: day,
            hours: fix(hours),
            minutes: fix(minutes),
            seconds: fix(seconds),
            month_name: months[month - 1],
            month_name_en: months_en[month - 1],
            month_abbr: months_abbr[month - 1],
            day_name: days[day],
            day_name_en: days_en[day],
            day_abbr: days_abbr[day],
            // yyyy-MM-dd
            ymd: year + '-' + fix(month) + '-' + fix(date),
            // yyyy.MM.dd
            ymd2: year + '.' + fix(month) + '.' + fix(date),
            // HH:mm:ss
            hms: fix(hours) + ':' + fix(minutes) + ':' + fix(seconds),
            // yyyy-MM-dd HH:mm:ss
            full: year + '-' + fix(month) + '-' + fix(date) + ' ' + fix(hours) + ':' + fix(minutes) + ':' + fix(seconds),
            // yyyy.MM.dd HH:mm:ss
            full2: year + '.' + fix(month) + '.' + fix(date) + ' ' + fix(hours) + ':' + fix(minutes) + ':' + fix(seconds),
            // yyyy/MM/dd HH:mm
            ymdhm: year + '/' + fix(month) + '/' + fix(date) + ' ' + fix(hours) + ':' + fix(minutes),
            // yy/MM/dd HH:mm
            ymdhm2: (year+'').substring(2,4) + '/' + fix(month) + '/' + fix(date) + ' ' + fix(hours) + ':' + fix(minutes),
            // MM/dd HH:mm
            mdhm: fix(month) + '/' + fix(date) + ' ' + fix(hours) + ':' + fix(minutes),
            // dd month yyyy HH:mm
            west: fix(date) + ' ' + months_abbr[month - 1] + ' ' + year + ' ' + fix(hours) + ':' + fix(minutes)
        };
    },
    urlsplicing:function (u, data){
        let url = config.api + u;
        if(typeof(url) == 'undefined' || url == null || url == '') {
            return '';
        }
        if(typeof(data) == 'undefined' || data == null || typeof(data) != 'object') {
            return '';
        }
        url += (url.indexOf("?") != -1) ? "" : "?";
        for(var k in data) {
            url += ((url.indexOf("=") != -1) ? "&" : "") + k + "=" + encodeURIComponent(data[k]);
        }
        return url;
    },
    // 浮点数相除
    floatAccDiv : function (arg1, arg2) {
        let t1 = 0, t2 = 0, s1 = arg1.toString(), s2 = arg2.toString();
        try {
            t1 = s1.split(".")[1].length;
        } catch (e) {}
        try {
            t2 = s2.split(".")[1].length;
        } catch (e) {}
        return (Number(s1.replace(".", "")) / Number(s2.replace(".", ""))) * Math.pow(10, t2 - t1);
    },
    // 浮点数相乘
    floatAccMul : function (arg1, arg2) {
        let m = 0, s1 = arg1.toString(), s2 = arg2.toString();
        try {
            m += s1.split(".")[1].length;
        } catch (e) {}
        try {
            m += s2.split(".")[1].length;
        } catch (e) {}
        return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
    },
    // 浮点数加法
    floatAccAdd : function (arg1, arg2) {
        let r1 = 0, r2 = 0, m, c, s1 = arg1.toString(), s2 = arg2.toString();
        try {
            r1 = s1.split(".")[1].length;
        } catch (e) {}
        try {
            r2 = s2.split(".")[1].length;
        } catch (e) {}
        c = Math.abs(r1 - r2);
        m = Math.pow(10, Math.max(r1, r2));
        arg1 = Number(s1.replace(".", ""));
        arg2 = Number(s2.replace(".", ""));
        if (c > 0) {
            let cm = Math.pow(10, c);
            if (r1 > r2) {
                arg2 = Number(s2.replace(".", "")) * cm;
            } else {
                arg1 = Number(s1.replace(".", "")) * cm;
            }
        }
        return (arg1 + arg2) / m;
    },
    // 浮点数减法
    floatAccSub : function (arg1, arg2) {
        let r1 = 0, r2 = 0, m, n;
        try {
            r1 = arg1.toString().split(".")[1].length;
        } catch (e) {}
        try {
            r2 = arg2.toString().split(".")[1].length;
        } catch (e) {}
        m = Math.pow(10, Math.max(r1, r2));
        //动态控制精度长度
        n = (r1 >= r2) ? r1 : r2;
        return Number(((arg1 * m - arg2 * m) / m).toFixed(n));
    }
}

export default util;
